import {FormattedMessage, FormattedRelative, injectIntl, intlShape} from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, {Component} from 'react';

@injectIntl
export default class AddressbookInfo extends Component {
    static propTypes = {
        intl: intlShape,
        location: ImmutablePropTypes.map.isRequired,
    }

    render() {
        const {location, ...props} = this.props;
        const {formatMessage} = this.props.intl;

        const addressbook = location.get('addressbook');
        if (!addressbook) return null;

        const label = addressbook.get('type') === 'addressbook.personal'
            ? formatMessage({id: 'frontend.form_selector_addressbook.select.option.personal_addressbook'})
            : addressbook.get('name');

        const createdAt = location.get('createdAt').toString();

        return (
            <small {...props}>
                <FormattedMessage id='frontend.form_selector_shipping.label.addressbook'/>
                {': '}
                <span>{label}</span>
                <span><br/></span>
                <FormattedMessage id='frontend.addressbook.label.created_at'/>
                {': '}
                <FormattedRelative value={createdAt}/>
            </small>
        );
    }
}
